export const MobileMenuPTBRTranslations = {
  mobileMenuCloseButtonLabel: 'Botão para fechar menu',
};
